import { render, staticRenderFns } from "./BpjsKetenagakerjaanDetailForm.vue?vue&type=template&id=47ffdacc&"
import script from "./BpjsKetenagakerjaanDetailForm.vue?vue&type=script&lang=js&"
export * from "./BpjsKetenagakerjaanDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports